import { render, staticRenderFns } from "./endorsement-dailog.vue?vue&type=template&id=373a0272&scoped=true&"
import script from "./endorsement-dailog.vue?vue&type=script&lang=js&"
export * from "./endorsement-dailog.vue?vue&type=script&lang=js&"
import style0 from "./endorsement-dailog.vue?vue&type=style&index=0&id=373a0272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a0272",
  null
  
)

export default component.exports